import * as React from "react";
import type { SVGProps } from "react";
const HairSalon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_6262)">
      <g clipPath="url(#clip1_4355_6262)">
        <path
          fill="currentColor"
          d="m12 9-1.8516-1.8516c.2297-.5906.3516-1.228.3516-1.8984C10.5 2.3484 8.1516 0 5.25 0S0 2.3484 0 5.25s2.3484 5.25 5.25 5.25c.6703 0 1.3078-.1266 1.8984-.3516L9 12l-1.8516 1.8516C6.5578 13.6219 5.9204 13.5 5.25 13.5 2.3484 13.5 0 15.8484 0 18.75S2.3484 24 5.25 24s5.25-2.3484 5.25-5.25c0-.6703-.1266-1.3078-.3516-1.8984L23.4 3.6a.846.846 0 0 0 0-1.2c-1.3266-1.3266-3.4734-1.3266-4.8 0zm1.0594 7.0594L18.6 21.6c1.3266 1.3266 3.4734 1.3266 4.8 0a.846.846 0 0 0 0-1.2l-7.3406-7.3406zM3 5.25a2.25 2.25 0 1 1 4.5001 0A2.25 2.25 0 0 1 3 5.25M5.25 16.5a2.2495 2.2495 0 0 1 2.0787 1.389 2.2495 2.2495 0 0 1-.4877 2.452A2.25 2.25 0 0 1 5.25 21a2.2495 2.2495 0 0 1-2.0787-1.389 2.2495 2.2495 0 0 1 .4877-2.452A2.25 2.25 0 0 1 5.25 16.5"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4355_6262">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4355_6262">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default HairSalon;
